import React, { useMemo, useEffect } from 'react';

const LogoutPage = () => {
  const isQaOrPrd = useMemo(() => process.env.REACT_APP_ENV === 'qa' || process.env.REACT_APP_ENV === 'prd', []);

  useEffect(() => {
    if (isQaOrPrd) {
      window.location.replace('https://www.samsung.net');
    } else {
      window.location.replace('/');
    }
  }, [isQaOrPrd]);

  return <></>
};

export default LogoutPage;
